import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const AnchorLogoIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 270 324"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Logo" fill="none" fillRule="evenodd">
      <g id="Anchor-mark" fill={fillColor}>
        <path
          d="M139.451099,170.175656 C137.178172,179.391093 131.663375,187.20701 124.314367,191.290852 L118.626062,194.450654 L128.998181,212.266071 L134.453096,209.218546 C142.230469,204.876396 148.824876,198.155802 153.522418,189.78542 C158.263435,181.33484 160.860469,171.530059 161.032079,161.436566 L161.034367,161.328871 L161.032079,161.218885 C160.860469,151.125392 158.263435,141.322902 153.522418,132.872323 C148.824876,124.501941 142.230469,117.781347 134.453096,113.436905 L128.998181,110.389381 L118.626062,128.204798 L124.314367,131.3646 C131.906318,135.583444 137.540783,143.785193 139.665835,153.39823 L71.7646265,153.39823 C68.6677938,147.440326 62.4422463,143.362832 55.2835228,143.362832 C45.0464042,143.362832 36.7175906,151.701135 36.7175906,161.952733 C36.7175906,172.204331 45.0464042,180.544925 55.2835228,180.544925 C62.5744689,180.544925 68.897449,176.314254 71.9329978,170.175657 L139.451099,170.175656 Z M135,324 C60.4415588,324 0,251.470129 0,162 C0,72.5298705 60.4415588,0 135,0 C209.558441,0 270,72.5298705 270,162 C270,251.470129 209.558441,324 135,324 Z M209.336788,173.289367 C205.483568,211.429254 184.517381,243.561163 155.343653,259.369338 L166.374754,277.846962 C204.209076,257.238363 230.59128,213.489197 231.476788,162.577203 C230.59128,111.669791 204.209076,67.9206256 166.374754,47.3097345 L155.343653,65.7873583 C184.517381,81.5955337 205.48128,113.729735 209.336788,151.86733 L209.638822,162.577203 L209.336788,173.289367 Z M147.480535,245.320795 L150.066129,243.87723 C163.291552,236.489847 174.540027,225.000908 182.5874,210.656919 C190.808671,196.005887 195.311722,178.980993 195.609179,161.419918 L195.611467,161.367216 L195.609179,161.316806 C195.311722,143.755731 190.808671,126.730837 182.5874,112.079805 C174.540027,97.735816 163.291552,86.2468769 150.066129,78.8594936 L147.480535,77.4159292 L136.984857,95.4444441 L139.677993,96.94071 C149.002145,102.121502 157.147908,110.063397 163.238925,119.911714 C169.453501,129.95938 173.386806,141.789734 174.620112,154.137938 L174.819179,161.367216 L174.620112,168.598786 C173.386806,180.944699 169.453501,192.777344 163.238925,202.82501 C157.150196,212.671035 149.002145,220.615222 139.677993,225.793723 L136.984857,227.29228 L147.480535,245.320795 Z"
          id="anchor"
        />
      </g>
    </g>
  </svg>
);

AnchorLogoIcon.defaultProps = defaultProps;

export default AnchorLogoIcon;
